import React, { useEffect, useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import TuneIcon from '@mui/icons-material/Tune';
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import { styled } from '@mui/system';
import {
    Unstable_NumberInput as BaseNumberInput,
    numberInputClasses,
} from '@mui/base/Unstable_NumberInput';
import { useNavigate } from 'react-router-dom';
import { pendingApprovalList} from "../../api/approval";
import { toast } from 'react-toastify';
import { useApprovalFilter } from "../../Components/Hooks/UseApprovalFilter";
import { useDispatch } from "react-redux";
import { StorePageHeaderName } from "../../store/pageHeader/action";
import useTitle from '../../helpers/helper';

const ApprovalRequisitionHistory = () => {
  useTitle("Procurement-approval-requisition");

  const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Approval Requisition History'));

    const navigate = useNavigate();
    const gotToRequisition=()=>{
        if(checkedRows.length ===0){
            toast.error('No Requisition is selected!')
            return
        }
      navigate("/sales-head/after-aproval-add-requisition" , { state: { checkedRows } });
    }
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [savedRequisition, setSavedRequisition] = useState([])
    const [checkedRows, setCheckedRows] = useState([]);
    const [gridLoad, setGridLoad] = useState(false)

    const openModal = () => {
        setModalIsOpen(true);
    };
    const closeModal = () => {
        setModalIsOpen(false);
    };
    const top100Films = [
        { label: 'The Shawshank Redemption', year: 1994 },
        { label: 'The Godfather', year: 1972 },
        { label: 'The Godfather: Part II', year: 1974 },
        { label: 'The Dark Knight', year: 2008 },
        { label: '12 Angry Men', year: 1957 },]
    const [showList, setShowList] = useState(false);

    const toggleList = () => {
        setShowList(!showList);
    };
    // const [rows, setRows] = useState([
    //     {
    //         productName: '',
    //         quantity: '',
    //         value: ''
    //     }
    // ])
    // const handleAddRow = () => {
    //     setRows([...rows, { productName: '', quantity: '', value: '' }]);
    // };
    // const handleDeleteRow = (index) => {
    //     const updatedRows = [...rows];
    //     updatedRows.splice(index, 1);
    //     setRows(updatedRows);
    // };
    // const handleInputChange = (index, field, value) => {
    //     const updatedRows = [...rows];
    //     updatedRows[index][field] = value;
    //     setRows(updatedRows);
    // };
    const handleSelectAllChange = (event) => {
      const isChecked = event.target.checked;
      if (isChecked) {
          setCheckedRows(savedRequisition);
      } else {
          setCheckedRows([]);
      }
  };
    const columns = [
        { field: 'Sl_No', resizable: false,sortable: false, headerName: (<div><Checkbox onChange={handleSelectAllChange}/><span>SL.No</span></div>), width: 110,
          renderCell: (params) => {
            return (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Checkbox
                        checked={checkedRows.length > 0 && checkedRows.some(checkedRow => checkedRow.id === params.row.id)}
                        onChange={(event) => handleCheckboxChange(event, params)}
                    />

                    <span>{params.row.Sl_No}</span>
                </div>
            )
        }
      },
        {
          field: 'Requisition_No',
          headerName: 'Requisition No',
          headerClassName: 'break-header',
          cellClassName: 'product_name_wrap',
        //   width: 160,
        sortable: false,
          resizable: false,
          flex: 1,
        },
        // {
        //     field: 'Executive_Name',
        //     headerName: 'Executive Name',
        //     headerClassName: 'table-header-background',
        //     width: 160,
        //     sortable: false,
        //     resizable: false,
        //   },
        {
          field: 'Requisition_Date',
          headerName: 'Requisition Date',
          headerClassName: 'break-header',
          flex: 1,
        //   width: 160,
        sortable: false,
          resizable: false,
        },
        {
          field: 'Product_Name',
          headerName: 'Product Name',
          headerClassName: 'break-header',
          cellClassName: 'product_name_wrap center-aligndata ',
          width: 160,
          sortable: false,
          resizable: false,
          renderCell: (params) => {
            const productName = params.value;
            return (
              <div style={{cursor:'pointer'}}>
                {productName}
              </div>
            );
          },
        },
        {
          field: 'Total_Qty',
          headerName: 'Total Quantity',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          headerClassName: 'break-header',
          flex: 1,
        //   width: 160,
        },
        {
          field: 'approved',
          headerName: 'Approved',
          headerClassName: 'table-header-background',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
        //   width: 160,
        },
        {
          field: 'remaining',
          headerName: 'Remaining',
          headerClassName: 'table-header-background',
          sortable: false,
          resizable: false,
          headerAlign: 'center',
          cellClassName: 'center-aligndata',
          flex: 1,
        //   width: 160,
        },
          {
            field: 'Allocation_QTY',
            headerName: 'Allocation (QTY)',
            headerClassName: 'break-header',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
          },
          {
            field: 'Arrival_Date',
            headerName: 'Arrival Date',
            headerClassName: 'break-header',
            sortable: false,
            flex: 1,
            // width: 160,
          },
          {
            field: 'Value',
            headerName: 'Value',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 1,
            // width: 160,
          },
          {
            field: 'Status',
            headerName: 'Status',
            headerClassName: 'table-header-background',
            sortable: false,
            resizable: false,
            width: 160,
            flex: 1,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            renderCell: (params) => {
                let status = params.value;
                // Define the color for the chip based on the status
                let chipColor = 'default';
                if (status == 'SAVED') {
                    status = 'Approval pending'
                  chipColor = 'error'; // Red color for waiting for response
                } else if (status == 'approved') {
                  chipColor = 'success'; // Green color for approved
                }

                // Render the Chip component with the outlined variant and appropriate color
                return <Chip className="status_badge mt-1" label={status} variant="outlined" color={chipColor} />;
              },
          },
      ];

    const blue = {
        100: '#DAECFF',
        200: '#80BFFF',
        400: '#3399FF',
        500: '#007FFF',
        600: '#0072E5',
        700: '#0059B2',
    };

    const grey = {
        50: '#F3F6F9',
        100: '#E5EAF2',
        200: '#DAE2ED',
        300: '#C7D0DD',
        400: '#B0B8C4',
        500: '#9DA8B7',
        600: '#6B7A90',
        700: '#434D5B',
        800: '#303740',
        900: '#1C2025',
    };

    const StyledInputRoot = styled('div')(
        ({ theme }) => `
            font-family: 'IBM Plex Sans', sans-serif;
            font-weight: 400;
            border-radius: 4px;
            color: #0060AA;
            background: transparent;
            border: 1px solid #0060AA;
            box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
            };
            display: grid;
            grid-template-columns: 1fr 19px;
            grid-template-rows: 1fr 1fr;
            overflow: hidden;
            column-gap: 8px;
            padding: 3px 4px;

            &.${numberInputClasses.focused} {
              border-color: #0060AA;
            }

            &:hover {
              border-color: #0060AA;
            }

            // firefox
            &:focus-visible {
              outline: 0;
            }
          `,
    );

    const StyledInputElement = styled('input')(
        ({ theme }) => `
            font-size: 1rem;
            font-family: inherit;
            font-weight: 400;
            line-height: 1.5;
            grid-column: 1/2;
            grid-row: 1/3;
            color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
            background: inherit;
            border: none;
            border-radius: inherit;
            padding: 2px 12px;
            outline: 0;
          `,
    );

    const StyledButton = styled('button')(
        ({ theme }) => `
            display: flex;
            flex-flow: row nowrap;
            justify-content: center;
            align-items: center;
            appearance: none;
            padding: 0;
            width: 19px;
            height: 19px;
            font-family: system-ui, sans-serif;
            font-size: 0.875rem;
            line-height: 1;
            box-sizing: border-box;
            background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
            border: 0;
            color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
            transition-property: all;
            transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
            transition-duration: 120ms;

            &:hover {
              background: ${theme.palette.mode === 'dark' ? grey[800] : grey[50]};
              border-color: ${theme.palette.mode === 'dark' ? grey[600] : grey[300]};
              cursor: pointer;
            }

            &.${numberInputClasses.incrementButton} {
              grid-column: 2/3;
              grid-row: 1/2;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              border: 1px solid;
              border-bottom: 0;
              border-color: transparent;
              background: transparent;
              color: #0060AA;

              &:hover {
                cursor: pointer;
                color: #0060AA;
                background: transparent;
                border-color:transparent;
              }
            }

            &.${numberInputClasses.decrementButton} {
              grid-column: 2/3;
              grid-row: 2/3;
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
              border: 1px solid;
              border-color:transparent;
              background: transparent;
              color: #0060AA;
            }

            &:hover {
              cursor: pointer;
              color: #0060AA;
              background: transparent;
              border-color: transparent;
            }

            & .arrow {
              transform: translateY(-1px);
            }

            & .arrow {
              transform: translateY(-1px);
            }
          `,
    );
    const CustomNumberInput = React.forwardRef(function CustomNumberInput(props, ref) {
        return (
            <BaseNumberInput
                slots={{
                    root: StyledInputRoot,
                    input: StyledInputElement,
                    incrementButton: StyledButton,
                    decrementButton: StyledButton,
                }}
                slotProps={{
                    incrementButton: {
                        children: '▴',
                    },
                    decrementButton: {
                        children: '▾',
                    },
                }}
                {...props}
                ref={ref}
            />
        );
    });

    const getSavedRequisition = async (payload = {}) => {
      try {
        setGridLoad(true);
        const savedRequisition = await pendingApprovalList(payload);
        const results = savedRequisition.data;

        let formattedRequisitions = [];
        if (
          savedRequisition.statusCode === 200 &&
          results.pendingApproval.length > 0
        ) {
          formattedRequisitions = results.pendingApproval.map(
            (result, index) => ({
              id: result.id, // Assuming index + 1 as ID
              Sl_No: index + 1, // Serial Number
              Requisition_No: result.procurementRequisition.requisition_number,
              Requisition_Date: result.procurementRequisition.requisition_date,
              Product_Name: result.item_name,
              Total_Qty: result.total_qty,
              remaining: result.total_qty - result.modified_qty,
              approved: result.modified_qty,
              Value: result.modified_qty * result.dp,
              Status: result.status,
              Requisition_id: result.procurementRequisition.id,
              Requisition_item_id: result.id,
              Item_no: result.item_no,
              Executive_Name:
                result.user.first_name + " " + result.user.last_name,
              p_type: result.p_type,
              vertical: result.vertical,
              itemseg: result.itemseg,
              category: result.category,
              dp: result.dp,
              mop: result.mop,
              vcode: result.v_code,
              vname: result.v_name,
              vtype: result.v_type

            })
          );
        }
        setSavedRequisition(formattedRequisitions);
      } catch (error) {
        toast.error("Error occur while fetching sales head approval pending");
        console.log(error);
      } finally {
        setGridLoad(false);
      }
    };
    const {
      productList,
      reqNoList,
      executiveList,
      filterPayload,
      setFilterPayload,
      handleSearch,
      handleReset
    } = useApprovalFilter({
        showList,
        status: 'SAVED',
        requisition_role: 'SALES_HEAD',
        callback: getSavedRequisition
    });

    useEffect (()=>{
        getSavedRequisition()
    },[])
    const handleCheckboxChange = (event, params) => {
        const isChecked = event.target.checked;
        const row = params.row; // Get the entire row object

        if (isChecked) {
            setCheckedRows(prevRows => [...prevRows, row]);
        } else {
            const updatedRows = checkedRows.filter(checkedRow => checkedRow.id !== row.id);
            setCheckedRows(updatedRows);
        }
    };

    return (
        <React.Fragment>
            <Container fluid>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop:'10px' }}>
                        <div style={{ fontSize: '20px', }}>
                            <h4 className="mb-0 requisition_text">Approval Requisition History</h4>
                        </div>
                        <div className="d-flex align-items-center">
                            <div><button onClick={toggleList} variant="outlined" className="filter_button"><span className="me-2"><TuneIcon /></span>Filter</button></div>
                            {/* <div className="ms-2"><button className="save_button" onClick={() => gotToRequisition()}>Submit</button></div> */}
                        </div>
                    </div>
                    {showList && (

                        <div className="mt-2" style={{ display: 'flex', gap: '10px', alignItems: 'center',flexWrap:'wrap' }}>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={productList}
                                    onChange={(_, value) => setFilterPayload({...filterPayload, product:value})}
                                    value={filterPayload.product}
                                    sx={{ width: 230 }}
                                    renderInput={(params) => <TextField {...params} label="Search Product Name" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={reqNoList}
                                    onChange={(_, value) => setFilterPayload({...filterPayload, reqNo:value})}
                                    value={filterPayload.reqNo}
                                    sx={{
                                        width: 180
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Requisition Number" />}
                                />
                            </div>
                            <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={executiveList}
                                    onChange={(_, value) => setFilterPayload({...filterPayload, executive:value})}
                                    value={filterPayload.executive}
                                    sx={{
                                        width: 180
                                    }}
                                    renderInput={(params) => <TextField {...params} label="Executive" />}
                                />
                            </div>
                            <div className="d-flex">
                                <div>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker className='date_picker'
                                            label="From Date"
                                            value={filterPayload.startDate}
                                            maxDate={filterPayload.endDate}
                                            onChange={(value) => setFilterPayload({...filterPayload, startDate:value})}
                                        // value={selectedDate}
                                        // onChange={handleDateChange}
                                        />
                                    </LocalizationProvider>
                                </div>
                                <div className="ms-2">
                                    <LocalizationProvider className='date_picker' dateAdapter={AdapterDayjs}>
                                        <DatePicker className='date_picker'
                                            label="To Date"
                                            value={filterPayload.endDate}
                                            minDate={filterPayload.startDate}
                                            onChange={(value) => setFilterPayload({...filterPayload, endDate:value})}
                                        // value={selectedEndDate}
                                        // onChange={handleEndDateChange}
                                        />
                                    </LocalizationProvider>
                                </div>
                            </div>
                            {/* <div>
                                <Autocomplete
                                    className="data_field"
                                    disablePortal
                                    id="combo-box-demo"
                                    options={top100Films}
                                    sx={{ width: 120 }}
                                    renderInput={(params) => <TextField {...params} label="Status" />}

                                />
                            </div> */}
                            <div className="d-flex align-items-center">
                                <Button className="me-2 search_button" onClick={handleSearch}>Search</Button>
                                <ReplayIcon onClick={handleReset}/>
                            </div>

                        </div>
                    )}

                    <Box sx={{ height: '100%', width: '100%', marginBottom: '1.5rem', marginTop:'10px' }}>
                        <DataGrid
                             autoHeight
                            className="table_header_background"
                            headerClassName="custom-header-cell"
                            getRowHeight={() => 'auto'}
                            rows={savedRequisition}
                            columns={columns}
                            loading={gridLoad}
                            // initialState={{
                            //     pagination: {
                            //         paginationModel: {
                            //             pageSize: 5,
                            //         },
                            //     },
                            // }}
                            pageSizeOptions={[]}
                            disableRowSelectionOnClick
                            disableColumnMenu
                            componentsProps={{
                              cell: {
                                disableClick: true,
                              },
                            }}
                            sx={{
                              '& .MuiDataGrid-cell': {
                                '& .MuiDataGrid-cell--textOverflow': {
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                },
                              },
                            }}
                        />
                    </Box>
                </div>
                {/* <Card>
                        <CardBody>
                            <div>
                                <table id="table" className='requisition_balance'>
                                    <thead className='booked_balance_listHeader'>
                                        <tr>
                                            <th className="text-center">Item Count</th>
                                            <th className="text-center">Total Quantity</th>
                                            <th className="text-center">Total Approved</th>
                                            <th className="text-center">Total Remaining</th>

                                        </tr>
                                    </thead>
                                    <tbody className='requisition_balance_table_body'>
                                        
                                            <tr>
                                                <td className="text-center">{savedRequisition.length}</td>
                                                <td className="text-center">{savedRequisition.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.Total_Qty;
                                                }, 0)}</td>
                                                <td className="text-center">{savedRequisition.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.approved;
                                                }, 0)}</td>
                                                <td className="text-center">{savedRequisition.reduce((accumulator, currentObject) => {
                                                  return accumulator + currentObject.remaining;
                                                }, 0)}</td>
                                            </tr>
                                        
                                    </tbody>
                                </table>
                            </div>
                        </CardBody>
                </Card> */}
            </Container>
        </React.Fragment>
    );
};

export default ApprovalRequisitionHistory;
